<script setup lang="ts">
import DialogCheckAddress from '@/components/MenuByPoints/dialogs/DialogCheckAddress.vue'
</script>

<template>
  <dialog-check-address />
</template>
